import { ImageStyled } from 'page/Authentication/component/Image/styled';

const ImageIcon = ({ src, alt }) => {
  return (
    <ImageStyled>
      <img src={src} alt={alt ?? 'image'} />
    </ImageStyled>
  );
};

export default ImageIcon;
